import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorPageComponent } from './error-page.component';
import { ExternalPageModule } from '../external-page/external-page.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faExclamationCircle 
} from '@fortawesome/free-solid-svg-icons';

@NgModule({
  declarations: [
    ErrorPageComponent
  ],
  imports: [
    CommonModule,
    ExternalPageModule,
    FlexLayoutModule,
    FontAwesomeModule
  ],
  exports: [
    ErrorPageComponent
  ]
})
export class ErrorPageModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faExclamationCircle);
  }
}
